// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: white;
}

.qr-toolbar {
  text-align: right;
}

#downladableQr div {
  margin-left: 35px;
  margin-right: 35px;
}

#options-qr {
  justify-content: center;
}
#options-qr ion-col {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
}
#options-qr ion-col ion-icon {
  padding-right: 8px;
}

#title-modal {
  font-weight: 700;
  font-size: 17px;
  color: var(--ion-text-color);
  margin: 0px 0px 16px 0px;
  padding-left: 16px;
  padding-right: 16px;
}

#subtitle-modal {
  font-weight: 400;
  font-size: 17px;
  color: var(--ion-text-color);
  margin: 0px 0px 0px 0px;
}

.break-line {
  white-space: pre-wrap;
}

#scan {
  font-weight: 500;
  font-size: 14px;
  color: var(--ion-text-color);
  margin: 7px 0px 7px 42px;
}

#goToSite {
  color: var(--ion-color-secondary);
}

.question-mark {
  width: var(--question-mark-width, 24px);
  height: var(--question-mark-height, 24px);
  background: #dedede;
  background: var(--question-mark-background, var(--boxx-app-lightgray, #dedede));
  color: var(--ion-text-color);
  color: var(--question-mark-color, var(--ion-text-color));
  border-radius: var(--question-mark-border-radius, 50%);
  display: inline-flex;
  align-items: var(--question-mark-align-items, center);
  justify-content: var(--question-mark-justify-content, center);
  font-size: var(--question-mark-font-size, 14px);
  font-weight: var(--question-mark-font-weight, 600);
  margin-top: 10px;
}

p {
  padding: 10px;
}

.item-input {
  --background: #ebebeb;
  border-radius: 10px;
  border: 1.5px solid #b8b2b2;
}
.item-input ion-input {
  --padding-top: 15px !important;
  font-size: 17px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/qr-component/totalplay/totalplay.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGE;EACE,iBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,uBAAA;AADF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,wBAAA;AAFF;;AAKA;EACE,iCAAA;AAFF;;AAMA;EACI,uCAAA;EACA,yCAAA;EACA,mBAAA;EACA,+EAAA;EACA,4BAAA;EACA,wDAAA;EACA,sDAAA;EACA,oBAAA;EACA,qDAAA;EACA,6DAAA;EACA,+CAAA;EACA,kDAAA;EACA,gBAAA;AAHJ;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,2BAAA;AAHF;AAKE;EACE,8BAAA;EACA,0BAAA;AAHJ","sourcesContent":["ion-content {\n  --background: white;\n}\n\n.qr-toolbar {\n  text-align: right;\n}\n\n#downladableQr {\n  div {\n    margin-left: 35px;\n    margin-right: 35px;\n  }\n}\n\n#options-qr {\n  justify-content: center;\n  ion-col {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 14px;\n    margin-bottom: 10px;\n\n    ion-icon {\n      padding-right: 8px;\n    }\n  }\n}\n\n#title-modal {\n  font-weight: 700;\n  font-size: 17px;\n  color: var(--ion-text-color);\n  margin: 0px 0px 16px 0px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n#subtitle-modal {\n  font-weight: 400;\n  font-size: 17px;\n  color: var(--ion-text-color);\n  margin: 0px 0px 0px 0px;\n}\n\n.break-line {\n  white-space: pre-wrap;\n}\n\n#scan {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--ion-text-color);\n  margin: 7px 0px 7px 42px;\n}\n\n#goToSite {\n  color: var(--ion-color-secondary);\n}\n\n\n.question-mark {\n    width: var(--question-mark-width, 24px);\n    height: var(--question-mark-height, 24px);\n    background: #dedede;\n    background: var(--question-mark-background, var(--boxx-app-lightgray, #dedede));\n    color: var(--ion-text-color);\n    color: var(--question-mark-color, var(--ion-text-color));\n    border-radius: var(--question-mark-border-radius, 50%);\n    display: inline-flex;\n    align-items: var(--question-mark-align-items, center);\n    justify-content: var(--question-mark-justify-content, center);\n    font-size: var(--question-mark-font-size, 14px);\n    font-weight: var(--question-mark-font-weight, 600);\n    margin-top: 10px;\n}\n\np{\n  padding: 10px;\n}\n\n.item-input{\n  --background: #ebebeb;\n  border-radius: 10px;\n  border: 1.5px solid #b8b2b2;\n\n  ion-input{\n    --padding-top: 15px !important;\n    font-size: 17px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
